import {
  List,
  Datagrid,
  TextField,
  FunctionField,
  DeleteButton,
  BulkDeleteButton,
} from 'react-admin';
import { Box, LinearProgress, Typography } from '@mui/material';
import { RelativeTimeField } from '../../../shared/components/RelativeTimeField';

interface UserListenedStoriesListProps {
  userId: string;
}

export const UserListenedStoriesList = ({
  userId,
}: UserListenedStoriesListProps) => {
  return (
    <List
      resource="user_listened_stories"
      filter={{ userId }}
      perPage={25}
      sort={{ field: 'lastListenedAt', order: 'DESC' }}
      storeKey={false}
      actions={false}
      pagination={false}
      sx={{ '& .RaList-content': { boxShadow: 'none' } }}
    >
      <Datagrid
        bulkActionButtons={
          <BulkDeleteButton label="" mutationMode="pessimistic" />
        }
        size="small"
        rowClick={false}
      >
        <TextField source="storySlug" label="Story Slug" />
        <FunctionField
          source="ratio"
          label="Progress"
          render={(record: any) => {
            const percentage = Math.round(record.ratio * 100);
            return (
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1,
                  minWidth: 120,
                }}
              >
                <LinearProgress
                  variant="determinate"
                  value={percentage}
                  sx={{ flexGrow: 1, height: 8, borderRadius: 1 }}
                />
                <Typography
                  variant="body2"
                  sx={{ minWidth: 35, fontSize: '0.75rem' }}
                >
                  {percentage}%
                </Typography>
              </Box>
            );
          }}
        />
        <TextField source="positionSec" label="Position" />
        <RelativeTimeField source="lastListenedAt" label="Last Listened At" />
        <DeleteButton label="" mutationMode="pessimistic" />
      </Datagrid>
    </List>
  );
};
